interface GeoRegion {
  region: string[];
  cbid: string;
}

export const formatGeoRegion = (geoRegion: GeoRegion): string =>
  JSON.stringify({
    region: geoRegion.region.join(', '),
    cbid: geoRegion.cbid,
  });
